import { Box } from '@common-fe/common-fe';
import styled from 'styled-components';

export const ControlWithLock = styled(Box)`
  position: relative;
  width: 100%;
`;

export const LockAside = styled(Box)<{ $hasNotes?: boolean }>`
  position: absolute;
  left: 100%;
  top: 50%;
  transform: translateY(-50%);
  margin-left: ${({ theme, $hasNotes }) => ($hasNotes ? theme.spacings.spacing48 : theme.spacings.spacing12)};
`;

export const LockBesideControl = styled(Box)`
  position: absolute;
  left: 100%;
  top: 0;
  height: ${({ theme }) => theme.controls.height};
  justify-content: center;
  margin-left: ${({ theme }) => theme.spacings.spacing12};
`;
